import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

export const GeneralModal = ({ children, onClose }) => {

    return (
        <div className = 'generalModal__container' >{
            onClose?
                <div className = 'generalModal__close-wrap' >
                    <button className = 'generalModal__close' onClick = { onClose } >
                        <i className = { `icon icon-cancel` } />
                    </button>
                </div>: null}

            <div className = 'generalModal__content'>{children}</div>

        </div>
    );

};

GeneralModal.propTypes = {
    onClose: PropTypes.func,
};
